"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  buildCleaner: true,
  cleaner: true,
  fieldTypeCleaners: true,
  buildGetValue: true,
  getValue: true
};
exports.buildCleaner = buildCleaner;
Object.defineProperty(exports, "fieldTypeCleaners", {
  enumerable: true,
  get: function get() {
    return _munge.fieldTypeCleaners;
  }
});
Object.defineProperty(exports, "buildGetValue", {
  enumerable: true,
  get: function get() {
    return _munge.buildGetValue;
  }
});
Object.defineProperty(exports, "getValue", {
  enumerable: true,
  get: function get() {
    return _munge.getValue;
  }
});
exports["default"] = exports.cleaner = void 0;

var _isFunction2 = _interopRequireDefault(require("lodash/fp/isFunction"));

var _munge = require("./munge");

var _clean = require("./clean");

Object.keys(_clean).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _clean[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _clean[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getMungeFunc(mungeOption) {
  if ((0, _isFunction2["default"])(mungeOption)) return mungeOption(_munge.fieldTypeCleaners);
  return (0, _munge.buildGetValue)(mungeOption);
}

function buildCleaner(mungeOption) {
  var cleaner = getMungeFunc(mungeOption);
  return function (node) {
    return cleaner(node, cleaner);
  };
}

var cleaner = function cleaner(obj) {
  return (0, _munge.getValue)(obj, _munge.getValue);
};

exports.cleaner = cleaner;
var _default = cleaner;
exports["default"] = _default;